module.exports = __webpack_public_path__ + "img/Dantam Fashion 09.19ab7033.jpg";